import React, { useState, useEffect } from 'react';

const NecrovaCameras = () => {
  // State for cameras and their settings
  const [cameras, setCameras] = useState([
    { 
      id: 1, 
      name: 'warehouse', 
      type: 'video', 
      source: 'https://cdn.4fingerstudios.com/Necrova/Cameras/Wearhouse%20camera%20-%20Made%20with%20Clipchamp.mp4', 
      status: 'online',
      lastMotion: '03/20/2025 14:32:18',
      recording: true
    },
    
  ]);

  // State for selected camera
  const [selectedCamera, setSelectedCamera] = useState(cameras[0]);
  
  // State for editing camera name
  const [editingCamera, setEditingCamera] = useState(null);

  
  // State for system notifications
  const [notification, setNotification] = useState(null);
  
  // State for system stats
  const [systemStats, setSystemStats] = useState({
    totalCameras: cameras.length,
    onlineCameras: cameras.filter(cam => cam.status === 'online').length,
    recording: cameras.filter(cam => cam.recording).length,
    storageUsed: '42.7 GB',
    motionEvents: '127',
    lastBackup: '21/03/2025 12:00:00'
  });
  
  // Update system stats when cameras change
  useEffect(() => {
    setSystemStats({
      ...systemStats,
      totalCameras: cameras.length,
      onlineCameras: cameras.filter(cam => cam.status === 'online').length,
      recording: cameras.filter(cam => cam.recording).length
    });
  }, [cameras]);

  // Function to select a camera
  const handleSelectCamera = (camera) => {
    setSelectedCamera(camera);
    showNotification(`Viewing ${camera.name} camera feed`);
  };
  
  // Function to toggle camera status
  const toggleCameraStatus = (id) => {
    setCameras(cameras.map(camera => {
      if (camera.id === id) {
        const newStatus = camera.status === 'online' ? 'offline' : 'online';
        if (camera.id === selectedCamera.id) {
          setSelectedCamera({...camera, status: newStatus});
        }
        showNotification(`Camera ${camera.name} is now ${newStatus}`);
        return {...camera, status: newStatus};
      }
      return camera;
    }));
  };
  
  // Function to toggle recording status
  const toggleRecording = (id) => {
    setCameras(cameras.map(camera => {
      if (camera.id === id) {
        const newRecording = !camera.recording;
        if (camera.id === selectedCamera.id) {
          setSelectedCamera({...camera, recording: newRecording});
        }
        showNotification(`${newRecording ? 'Started' : 'Stopped'} recording on ${camera.name}`);
        return {...camera, recording: newRecording};
      }
      return camera;
    }));
  };
  
  // Function to start editing camera name
  const startEditingCamera = (camera) => {
    setEditingCamera(camera.id);
    setNewCameraName(camera.name);
  };
  
  // Function to save new camera name
  const saveNewCameraName = (id) => {
    if (newCameraName.trim()) {
      setCameras(cameras.map(camera => {
        if (camera.id === id) {
          if (camera.id === selectedCamera.id) {
            setSelectedCamera({...camera, name: newCameraName});
          }
          showNotification(`Camera renamed to ${newCameraName}`);
          return {...camera, name: newCameraName};
        }
        return camera;
      }));
    }
    setEditingCamera(null);
  };
  
  // Function to handle enter key press when editing camera name
  const handleKeyPress = (e, id) => {
    if (e.key === 'Enter') {
      saveNewCameraName(id);
    }
  };
  
  // Function to handle media type change
  const handleMediaTypeChange = (id, newType) => {
    setCameras(cameras.map(camera => {
      if (camera.id === id) {
        if (camera.id === selectedCamera.id) {
          setSelectedCamera({...camera, type: newType});
        }
        showNotification(`Changed ${camera.name} media type to ${newType}`);
        return {...camera, type: newType};
      }
      return camera;
    }));
  };
  
  // Function to handle media source change
  const handleSourceChange = (id, newSource) => {
    setCameras(cameras.map(camera => {
      if (camera.id === id) {
        if (camera.id === selectedCamera.id) {
          setSelectedCamera({...camera, source: newSource});
        }
        showNotification(`Updated ${camera.name} media source`);
        return {...camera, source: newSource};
      }
      return camera;
    }));
  };
  
  // Function to add new camera
  const addNewCamera = () => {
    if (newCamera.name.trim() && newCamera.source.trim()) {
      const newId = cameras.length > 0 ? Math.max(...cameras.map(c => c.id)) + 1 : 1;
      const cameraToAdd = {
        ...newCamera,
        id: newId,
        lastMotion: new Date().toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).replace(',', '')
      };
      
      setCameras([...cameras, cameraToAdd]);
      setSelectedCamera(cameraToAdd);
      setShowAddModal(false);
      showNotification(`Added new camera: ${newCamera.name}`);
      setNewCamera({
        name: '',
        type: 'image',
        source: '',
        status: 'online',
        recording: true
      });
    }
  };
  
  // Function to remove camera
  
  const [newCameraName, setNewCameraName] = useState('');

// State for modal visibility
const [showAddModal, setShowAddModal] = useState(false);

// State for new camera data
const [newCamera, setNewCamera] = useState({
  name: '',
  type: 'image',
  source: '',
  status: 'online',
  recording: true
});
  // Function to show notification
  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };
  
  // Function to render the media based on camera type
  const renderMedia = (camera) => {
    if (camera.status === 'offline') {
      return (
        <div className="offline-feed">
          <div className="offline-message">
            <span className="signal-icon">📶</span>
            <p>Signal Lost</p>
            <p className="offline-details">Camera is currently offline</p>
          </div>
        </div>
      );
    }
    
    switch (camera.type) {
      case 'video':
        return (
          <video 
            src={camera.source} 
            controls 
            autoPlay 
            muted 
            loop 
            className="camera-media"
          />
        );
      case 'gif':
        return (
          <img 
            src={camera.source} 
            alt={camera.name} 
            className="camera-media"
          />
        );
      case 'image':
      default:
        return (
          <div className="image-container">
            <img 
              src={camera.source} 
              alt={camera.name} 
              className="camera-media"
            />
            <div className="timestamp">
              {new Date().toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              }).replace(',', '')}
            </div>
          </div>
        );
    }
  };

  return (
    <div className="necrova-cameras-container">
      <div className="app-header">
        <div className="logo-container">
        <img 
          src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/Full.png" 
          width="40" 
          height="40" 
          alt="Description of image"
        />
          <h1 className="company-title">NECROVA</h1>
        </div>
        <h2 className="app-title">Security Monitoring System</h2>
        
        {notification && (
          <div className="notification">
            <span className="notification-message">{notification}</span>
            <span className="notification-progress"></span>
          </div>
        )}
      </div>
      
      <div className="app-content">
        <div className="camera-sidebar">
          <div className="sidebar-header">
            <h3>Security Cameras</h3>
          </div>
          
          <div className="camera-list">
            {cameras.map(camera => (
              <div 
                key={camera.id}
                className={`camera-item ${selectedCamera.id === camera.id ? 'selected' : ''} ${camera.status === 'offline' ? 'offline' : ''}`}
                onClick={() => handleSelectCamera(camera)}
              >
                <div className="camera-info">
                  <div className="camera-name-container">
                    {editingCamera === camera.id ? (
                      <input
                        type="text"
                        value={newCameraName}
                        onChange={(e) => setNewCameraName(e.target.value)}
                        onBlur={() => saveNewCameraName(camera.id)}
                        onKeyPress={(e) => handleKeyPress(e, camera.id)}
                        autoFocus
                        className="camera-name-input"
                      />
                    ) : (
                      <span className="camera-name" onDoubleClick={() => startEditingCamera(camera)}>
                        {camera.name}
                      </span>
                    )}
                    <div className={`status-indicator ${camera.status}`}></div>
                  </div>
                  <span className="last-motion">Last motion: {camera.lastMotion}</span>
                </div>
                <div className="camera-actions">
                  <button 
                    className={`action-button recording ${camera.recording ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleRecording(camera.id);
                    }}
                    title={camera.recording ? "Stop Recording" : "Start Recording"}
                  >
                    ⚫
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="system-stats">
            <h3>System Statistics</h3>
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-value">{systemStats.totalCameras}</div>
                <div className="stat-label">Total Cameras</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{systemStats.onlineCameras}</div>
                <div className="stat-label">Online</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{systemStats.recording}</div>
                <div className="stat-label">Recording</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{systemStats.storageUsed}</div>
                <div className="stat-label">Storage Used</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{systemStats.motionEvents}</div>
                <div className="stat-label">Motion Events</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{systemStats.lastBackup.split(' ')[0]}</div>
                <div className="stat-label">Last Backup</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="camera-display">
          <div className="display-header">
            <h3 className="display-title">
              <span className="camera-id">CAM-{selectedCamera.id}</span>
              {selectedCamera.name}
              <span className={`camera-status ${selectedCamera.status}`}>
                {selectedCamera.status.toUpperCase()}
              </span>
            </h3>
          </div>
          
          <div className="display-content">
            {renderMedia(selectedCamera)}
            
            {selectedCamera.recording && selectedCamera.status === 'online' && (
              <div className="recording-indicator">
                <span className="recording-dot"></span>
                <span className="recording-text">RECORDING</span>
              </div>
            )}
          </div>
        </div>
      </div>
  
      
      <div className="app-footer">
        <p className="footer-text">NECROVA INDUSTRIES • CONFIDENTIAL • AUTHORIZED ACCESS ONLY</p>
        <p className="system-info">SECURITY SYSTEM V3.4.1 • {new Date().getFullYear()}</p>
      </div>
      
      <style jsx>{`
        /* Global styles */
        .necrova-cameras-container {
          font-family: 'Arial', sans-serif;
          margin: 0;
          padding: 0;
          color: white;
          background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
        }
        
        /* Header styles */
        .app-header {
          background-color: rgba(15, 15, 26, 0.9);
          border-bottom: 1px solid rgba(138, 43, 226, 0.3);
          padding: 1rem 2rem;
          display: flex;
          align-items: center;
          position: relative;
        }
        
        .logo-container {
          display: flex;
          align-items: center;
          margin-right: 2rem;
        }
        
        .company-title {
          font-size: 1.5rem;
          font-weight: bold;
          letter-spacing: 3px;
          margin: 0 0 0 0.5rem;
          color: white;
        }
        
        .app-title {
          font-size: 1.2rem;
          color: #e94560;
          font-weight: normal;
          letter-spacing: 1px;
        }
        
        /* Notification styles */
        .notification {
          position: absolute;
          top: 0.5rem;
          right: 2rem;
          background-color: rgba(138, 43, 226, 0.8);
          border-radius: 4px;
          padding: 0.5rem 1rem;
          display: flex;
          flex-direction: column;
          animation: notificationSlide 0.3s ease-out;
          max-width: 300px;
          overflow: hidden;
        }
        
        .notification-message {
          margin-bottom: 0.5rem;
        }
        
        .notification-progress {
          height: 2px;
          background-color: white;
          animation: progressBar 3s linear;
          width: 100%;
          align-self: flex-start;
        }
        
        @keyframes notificationSlide {
          from { transform: translateY(-50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        @keyframes progressBar {
          from { width: 100%; }
          to { width: 0%; }
        }
        
        /* Content layout */
        .app-content {
          display: flex;
          flex: 1;
          height: calc(100vh - 130px);
        }
        
        /* Sidebar styles */
        .camera-sidebar {
          width: 350px;
          background-color: rgba(15, 15, 26, 0.8);
          border-right: 1px solid rgba(138, 43, 226, 0.3);
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        
        .sidebar-header {
          padding: 1rem;
          border-bottom: 1px solid rgba(138, 43, 226, 0.3);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .sidebar-header h3 {
          margin: 0;
          color: #8a2be2;
        }
        
        .add-camera-button {
          background-color: #8a2be2;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 0.4rem 0.8rem;
          cursor: pointer;
          font-size: 0.9rem;
          transition: all 0.3s ease;
        }
        
        .add-camera-button:hover {
          background-color: #7823c9;
          transform: translateY(-2px);
        }
        
        /* Camera list styles */
        .camera-list {
          overflow-y: auto;
          flex: 1;
          padding: 0.5rem;
        }
        
        .camera-item {
          background-color: rgba(26, 26, 46, 0.5);
          border: 1px solid rgba(138, 43, 226, 0.3);
          border-radius: 4px;
          margin-bottom: 0.5rem;
          padding: 0.8rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .camera-item:hover {
          background-color: rgba(26, 26, 46, 0.8);
          transform: translateX(3px);
        }
        
        .camera-item.selected {
          background-color: rgba(138, 43, 226, 0.2);
          border-color: #8a2be2;
          box-shadow: 0 0 5px rgba(138, 43, 226, 0.5);
        }
        
        .camera-item.offline {
          opacity: 0.7;
        }
        
        .camera-name-container {
          display: flex;
          align-items: center;
          margin-bottom: 0.3rem;
        }
        
        .camera-name {
          font-weight: bold;
          margin-right: 0.5rem;
        }
        
        .camera-name-input {
          background-color: rgba(15, 15, 26, 0.8);
          border: 1px solid #8a2be2;
          color: white;
          padding: 0.2rem 0.5rem;
          border-radius: 3px;
          width: 150px;
        }
        
        .status-indicator {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-left: 0.5rem;
        }
        
        .status-indicator.online {
          background-color: #4CAF50;
          box-shadow: 0 0 5px #4CAF50;
        }
        
        .status-indicator.offline {
          background-color: #F44336;
          box-shadow: 0 0 5px #F44336;
        }
        
        .last-motion {
          font-size: 0.8rem;
          color: #8a8aaa;
        }
        
        .camera-actions {
          display: flex;
          align-items: center;
        }
        
        .action-button {
          background-color: transparent;
          border: none;
          color: #8a8aaa;
          cursor: pointer;
          margin-left: 0.5rem;
          font-size: 1rem;
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          transition: all 0.2s ease;
        }
        
        .action-button:hover {
          background-color: rgba(138, 43, 226, 0.2);
          color: white;
        }
        
        .action-button.recording.active {
          color: #e94560;
          animation: pulse 1.5s infinite;
        }
        
        .action-button.power:hover {
          color: #4CAF50;
        }
        
        .action-button.delete:hover {
          color: #F44336;
        }
        
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
        
        /* System stats styles */
        .system-stats {
          padding: 1rem;
          border-top: 1px solid rgba(138, 43, 226, 0.3);
          background-color: rgba(15, 15, 26, 0.5);
        }
        
        .system-stats h3 {
          margin-top: 0;
          margin-bottom: 0.8rem;
          color: #8a2be2;
          font-size: 1rem;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0.8rem;
        }
        
        .stat-item {
          text-align: center;
          background-color: rgba(26, 26, 46, 0.5);
          border-radius: 4px;
          padding: 0.5rem;
        }
        
        .stat-value {
          font-size: 1.2rem;
          font-weight: bold;
          color: #e94560;
        }
        
        .stat-label {
          font-size: 0.8rem;
          color: #8a8aaa;
        }
        
        /* Camera display styles */
        .camera-display {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 1rem;
          background-color: rgba(15, 15, 26, 0.5);
        }
        
        .display-header {
          margin-bottom: 1rem;
        }
        
        .display-title {
          margin-top: 0;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
        }
        
        .camera-id {
          background-color: rgba(138, 43, 226, 0.2);
          color: #8a2be2;
          padding: 0.2rem 0.5rem;
          border-radius: 3px;
          font-size: 0.9rem;
          margin-right: 1rem;
        }
        
        .camera-status {
          margin-left: 1rem;
          font-size: 0.8rem;
          padding: 0.2rem 0.5rem;
          border-radius: 3px;
        }
        
        .camera-status.online {
          background-color: rgba(76, 175, 80, 0.2);
          color: #4CAF50;
        }
        
        .camera-status.offline {
          background-color: rgba(244, 67, 54, 0.2);
          color: #F44336;
        }
        
        .display-controls {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        
        .media-type-selector,
        .media-source-input {
          display: flex;
          align-items: center;
        }
        
        .media-type-selector span,
        .media-source-input span {
          margin-right: 0.5rem;
          font-size: 0.9rem;
          color: #8a8aaa;
        }
        
        .media-type-selector select,
        .media-source-input input {
          background-color: rgba(15, 15, 26, 0.8);
          border: 1px solid rgba(138, 43, 226, 0.3);
          color: white;
          padding: 0.4rem 0.8rem;
          border-radius: 3px;
        }
        
        .media-source-input input {
          width: 300px;
        }
        
        .display-content {
          flex: 1;
          background-color: #0f0f1a;
          border: 1px solid rgba(138, 43, 226, 0.3);
          border-radius: 4px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }
        
        .camera-media {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
        
        .offline-feed {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #1a1a2e;
        }
        
        .offline-message {
          text-align: center;
        }
        
        .offline-message p {
          margin: 0.5rem 0;
        }
        
        .signal-icon {
          font-size: 3rem;
          color: #F44336;
        }
        
        .offline-details {
          font-size: 0.9rem;
          color: #8a8aaa;
        }
        
        .image-container {
          position: relative;
        }
        
        .timestamp {
          position: absolute;
          bottom: 10px;
          right: 10px;
          background-color: rgba(15, 15, 26, 0.8);
          padding: 0.3rem 0.6rem;
          border-radius: 3px;
          font-size: 0.8rem;
          color: #8a8aaa;
        }
        
        .recording-indicator {
          position: absolute;
          top: 10px;
          left: 10px;
          background-color: rgba(233, 69, 96, 0.8);
          padding: 0.3rem 0.6rem;
          border-radius: 3px;
          display: flex;
          align-items: center;
          animation: fadeInOut 1.5s infinite;
        }
        
        .recording-dot {
          width: 10px;
          height: 10px;
          background-color: white;
          border-radius: 50%;
          margin-right: 0.5rem;
        }
        
        .recording-text {
          font-size: 0.8rem;
          font-weight: bold;
        }
        
        @keyframes fadeInOut {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
        
        .display-footer {
          display: flex;
          justify-content: space-between;
          margin-top: 1rem;
        }
        
        .controls-left,
        .controls-right {
          display: flex;
          gap: 0.5rem;
        }
        
        .control-button {
          background-color: rgba(26, 26, 46, 0.5);
          border: 1px solid rgba(138, 43, 226, 0.3);
          color: white;
          border-radius: 4px;
          padding: 0.5rem 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;
        }
        
        .control-button:hover {
          background-color: rgba(138, 43, 226, 0.2);
          border-color: #8a2be2;
        }
        
        .control-button.active {
          background-color: rgba(233, 69, 96, 0.2);
          border-color: #e94560;
          color: #e94560;
        }
        
        .control-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .control-icon {
          margin-right: 0.5rem;
        }
        
        /* Modal styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(15, 15, 26, 0.9);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          animation: fadeIn 0.3s ease;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .modal-content {
          background-color: #1a1a2e;
          border: 1px solid #8a2be2;
          border-radius: 6px;
          width: 500px;
          max-width: 90%;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          animation: slideUp 0.3s ease;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
        }
        
        @keyframes slideUp {
          from { transform: translateY(50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        .modal-header {
          padding: 1rem;
          border-bottom: 1px solid rgba(138, 43, 226, 0.3);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .modal-header h3 {
          margin: 0;
          color: #8a2be2;
        }
        
        .close-modal-button {
          background-color: transparent;
          border: none;
          color: #8a8aaa;
          font-size: 1.2rem;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .close-modal-button:hover {
          color: #e94560;
          transform: scale(1.1);
        }
        
        .modal-body {
          padding: 1rem;
          overflow-y: auto;
        }
        
        .input-group {
          margin-bottom: 1.2rem;
          position: relative;
        }
        
        .input-group label {
          display: block;
          margin-bottom: 0.5rem;
          color: #8a8aaa;
          font-size: 0.9rem;
        }
        
        .input-group input[type="text"],
        .input-group select {
          width: 100%;
          background-color: rgba(15, 15, 26, 0.8);
          border: 1px solid rgba(138, 43, 226, 0.3);
          color: white;
          padding: 0.8rem;
          border-radius: 4px;
          transition: all 0.3s ease;
        }
        
        .input-group input[type="text"]:focus,
        .input-group select:focus {
          border-color: #8a2be2;
          outline: none;
        }
        
        .input-focus-border {
          position: absolute;
          bottom: 0;
          left: 0;
          height: 2px;
          width: 0;
          background-color: #8a2be2;
          transition: all 0.3s ease;
        }
        
        .input-group input[type="text"]:focus ~ .input-focus-border,
        .input-group select:focus ~ .input-focus-border {
          width: 100%;
        }
        
        .checkbox-group {
          display: flex;
          align-items: center;
        }
        
        .checkbox-group input[type="checkbox"] {
          margin-right: 0.5rem;
          appearance: none;
          width: 18px;
          height: 18px;
          background-color: rgba(15, 15, 26, 0.8);
          border: 1px solid rgba(138, 43, 226, 0.3);
          border-radius: 3px;
          position: relative;
          cursor: pointer;
        }
        
        .checkbox-group input[type="checkbox"]:checked {
          background-color: #8a2be2;
        }
        
        .checkbox-group input[type="checkbox"]:checked::after {
          content: "✓";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 0.8rem;
        }
        
        .checkbox-group label {
          margin-bottom: 0;
          cursor: pointer;
        }
        
        .modal-footer {
          padding: 1rem;
          border-top: 1px solid rgba(138, 43, 226, 0.3);
          display: flex;
          justify-content: flex-end;
          gap: 1rem;
        }
        
        .cancel-button {
          background-color: transparent;
          border: 1px solid rgba(138, 43, 226, 0.3);
          color: #8a8aaa;
          padding: 0.6rem 1.2rem;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .cancel-button:hover {
          background-color: rgba(15, 15, 26, 0.8);
          color: white;
        }
        
        .add-button {
          background-color: #8a2be2;
          border: none;
          color: white;
          padding: 0.6rem 1.2rem;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .add-button:hover {
          background-color: #7823c9;
          transform: translateY(-2px);
        }
        
        .add-button:disabled {
          background-color: rgba(138, 43, 226, 0.5);
          cursor: not-allowed;
          transform: none;
        }
        
        /* Footer styles */
        .app-footer {
          background-color: rgba(15, 15, 26, 0.9);
          border-top: 1px solid rgba(138, 43, 226, 0.3);
          padding: 1rem 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .footer-text {
          margin: 0;
          font-size: 0.9rem;
          color: #8a2be2;
          letter-spacing: 1px;
        }
        
        .system-info {
          margin: 0;
          font-size: 0.8rem;
          color: #8a8aaa;
        }
        
        /* Responsive adjustments */
        @media (max-width: 1200px) {
          .app-content {
            flex-direction: column;
            height: auto;
          }
          
          .camera-sidebar {
            width: 100%;
            height: auto;
            border-right: none;
            border-bottom: 1px solid rgba(138, 43, 226, 0.3);
          }
          
          .camera-list {
            max-height: 300px;
          }
          
          .display-content {
            min-height: 400px;
          }
        }
        
        @media (max-width: 768px) {
          .app-header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .logo-container {
            margin-bottom: 1rem;
          }
          
          .notification {
            position: static;
            margin-top: 1rem;
            width: 100%;
            max-width: none;
          }
          
          .display-controls {
            flex-direction: column;
            gap: 0.5rem;
          }
          
          .media-source-input input {
            width: 100%;
          }
          
          .stat-item {
            padding: 0.3rem;
          }
          
          .stat-value {
            font-size: 1rem;
          }
          
          .stat-label {
            font-size: 0.7rem;
          }
          
          .display-footer {
            flex-direction: column;
            gap: 0.5rem;
          }
          
          .controls-left, .controls-right {
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
};

export default NecrovaCameras;
          